export default __webpack_public_path__ + "static/lozenge-dropdown-dont-1-light-b220f0fa60538eb0a4d1f943923e5ea4.png";